<template>
<div class="booking-navigation" :class="{ 'short' : productArea !== 1 }">
    <div class="times-wrapper">
        <transition name="scale">
            <div class="times-wrapper-window" v-if="numBookingTimes > 0 && bookingStore.view === 'map' && productArea === 1 && showTimeHighlight">
                {{ numBookingTimes }} tider från <b>{{ formatTime(firstBookingTime) }}</b>
            </div>
        </transition>
    </div>
    <div class="booking-navigation-btn" :class="{ 'active' : bookingStore.view === 'map' }" @click="setView('map')">
        Karta
    </div>
    <div class="booking-navigation-btn" :class="{ 'active' : bookingStore.view === 'list' }" style="left:74px;" @click="setView('list')">
        Lista
    </div>
    <div class="booking-navigation-btn" :class="{ 'active' : bookingStore.view === 'times' }" style="left:148px;" @click="setView('times')" v-if="productArea === 1">
        Tider<span class="position-absolute badge badge-sm bg-secondary" style="right: -2px; top: -2px; font-size: 10px; border-radius: 0.35rem;">NY</span>
    </div>
    <div class="booking-navigation-marker" :class="{ 'list' : bookingStore.view === 'list', 'times' : bookingStore.view === 'times' }"></div>
</div>
</template>

<script>
import moment from 'moment'
import { mapState, mapStores } from 'pinia'
import { useBookingStore } from '../../stores/bookingStore'
import axios from 'axios'
import { debounce } from 'lodash'

export default {
    data () {
        return {
            numBookingTimes: 0,
            firstBookingTime: null,
            showTimeHighlight:false,
            timeoutHandle:null,
        }
    },
    computed: {
        ...mapStores(useBookingStore),
        ...mapState(useBookingStore, {
            clinics: state => state.clinics,
            productArea: state => state.productArea
        })
    },
    watch: {
        clinics () {
            this.getBookingTimes()
        }
    },
    methods: {
        setView (view) {
            this.bookingStore.setView(view)
            this.showTimeHighlight = false

            if (view === 'map') {
                this.matomoTrackEvent('Booking', 'Navigation', 'Map')
            }

            if (view === 'list') {
                this.matomoTrackEvent('Booking', 'Navigation', 'List')
            }

            if (view === 'times') {
                this.matomoTrackEvent('Booking', 'Navigation', 'Times')
            }

        },

        getBookingTimes: debounce(function () {
            axios.post('/booking/getBookingTimes', {
                clinic_ids: this.clinics.map(clinic => clinic.id)
            })
                .then(response => {
                    console.log('getBookingTimes complete')
                    console.log(response.data)

                    this.numBookingTimes = response.data.numBookingTimes
                    this.firstBookingTime = response.data.firstBookingTime

                    if(this.bookingStore.trigTimeHighlight == true)
                    {
                        this.bookingStore.trigTimeHighlight = false
                        this.showTimeHighlight = true
                        clearTimeout(this.timeoutHandle)
                        this.timeoutHandle = setTimeout(() => {
                            this.showTimeHighlight = false
                          }, 4000);
                    }
                })
        }, 300),

        formatTime (time) {

            if(moment(Date.now()).format('YYYY') == moment(time).format('YYYY'))
            {
                return moment(time).format('D MMM [kl.] HH').toLowerCase()
            }
            return moment(time).format('D MMM YYYY [kl.] HH').toLowerCase()
            
        
        },
    }
}
</script>
<style type="text/css">
    /* --- Fade transition --- */
    .scale-enter-active, .scale-leave-active {
        transition: all 250ms;
    }

    .scale-enter, .scale-leave-to {
        opacity: 0;
        transform:scale(0) translateY(50px);
        transform-origin: bottom center;
    }

</style>
